import { ApiService } from "./api.service";
export default class TermService extends ApiService {
  namespace = "term";
  icon = "Gavel";
  name = "Term";
  favicon = "Mallet";
  window = 290;
  Width = 690;
  DOMAIN = -27;
  singular = this.terminology.term.singular;
  plural = this.terminology.term.plural;
  vowel = this.terminology.term.vowel;
  action = "action";
  singular = this.terminology.term.singular;
  plural = this.terminology.term.plural;
  vowel = this.terminology.term.vowel;
  constructor() {
    super("ar-terms");
  }
}
